module.exports = __webpack_public_path__ + "static/media/Promo-Allfresco-Fresas-Berries.de919170.webp";